export default __webpack_public_path__ + "static/media/STRIP.68f29163.png";